import {GameView} from "../base/GameView";
import {GameSplashScreen} from "../base/GameSplashScreen";

export class SplashLayer extends GameView {
    override onResize() {
        for (let i = this.children.length - 1; i >= 0; i--) {
            let child = this.getChildAt(i);
            if(child instanceof GameSplashScreen) {
                let splashScreen = child as GameSplashScreen;
                splashScreen.onResize();
            }
        }
    }
}
